import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";

export class SnpProfile{

    _id: string;
    
    lab:LabMDM;
   
    snpProfileName: string;
   
    fileName: string;
   
    requiredPercentage: number;
   
    compatibleUntil: number;
   
    incompatibleAbove: number;
   
    requiredPercentageBoth: number;
   
    compatibleUntilBoth: number;
   
    incompatibleAboveBoth: number;
    
    byExaminePanel: boolean;
   
    active: boolean;
   
    profileLength:number;
   
    file:any;

    version : number;

    creationDate: Date;

    lastModifiedDate: Date;
    
    history:OperetionHistoryDTO[];
}